/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Uppercase_Before_ColonInputs */



/**
* | output |
* | --- |
* | "Remove uppercase text before ':'" |
*
* @param {Remove_Uppercase_Before_ColonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_uppercase_before_colon = /** @type {((inputs?: Remove_Uppercase_Before_ColonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Uppercase_Before_ColonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le texte en majuscules avant ':'")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entferne den Großbuchstaben vor dem Doppelpunkt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi il testo maiuscolo prima di ':'")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалите заглавные буквы перед символом ':'.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar el texto en mayúsculas antes de ':'")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除冒号 (:) 之前的全部大写字母")
	if (locale === "ja") return /** @type {LocalizedString} */ ("':' の前の大文字のテキストを削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("':' से पहले के बड़े अक्षरों को हटा दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remova o texto em maiúsculas antes de ':'")
	return /** @type {LocalizedString} */ ("Remove uppercase text before ':'")
});